module.exports = __webpack_public_path__ + "static/media/like_product_2.766acb52.svg";